module.exports = __webpack_public_path__ + "img/dupontAnalyze.eb41617b.jpg";